export default __webpack_public_path__ + "static/media/279.9494ab96.jpg";